/* PrintABalls puck render core - shared by the artifact QA harness and the storefront */
var PAB_BUILDER="1.0.0";
// -- Geometry, in millimetres, matching build_masters.py exactly --------------
var C=38.1, R_PRINT=35.0, R_FACE=38.1, R_SAFE=31.75;
var CAP_EM=0.821, NAME_Y=21.0, NUM_Y=39.7, ARC_R=23.0;
var FS=function(cap,ff){return cap/capEm(ff);};
var nameFS=function(t){return Math.max(7.4, Math.min(10.0, 10.0*6/Math.max(t.length,1)));};
var arcFS =function(t){return Math.max(6.0, Math.min( 9.0,  9.0*6/Math.max(t.length,1)));};
var esc=function(s){return String(s).replace(/[<>&]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;'}[c];});};

// -- Font metrics and outline rendering ---------------------------------------
// Every sizing constant below used to be Oswald's. That silently broke the other
// four faces: Graduate's widest letter advance is 1.026 em against Oswald's 0.704,
// so names overflowed, and a cap height divided by Oswald's 0.821 came out the
// wrong physical height in every other font.
//
// When GLYPHS is present, text is emitted as outlines: no font has to be installed
// anywhere, the preview is byte-identical to what prints, and Illustrator cannot
// substitute a face. Without GLYPHS the old <text> path still works.
function capEm(ff){ return (typeof GLYPHS!=="undefined" && GLYPHS[ff]) ? GLYPHS[ff].cap : CAP_EM; }
function capLOf(ff){ return (typeof GLYPHS!=="undefined" && GLYPHS[ff]) ? GLYPHS[ff].capL : CAP_EM; }
function advEm(t,ff){                       // string advance in em, glyphs only
  if(typeof GLYPHS==="undefined" || !GLYPHS[ff]) return t.length*ADV_FALLBACK;
  var G=GLYPHS[ff].g, w=0;
  for(var i=0;i<t.length;i++){ var g=G[t.charAt(i)]; w += g ? g[0] : 600; }
  return w/1000;
}
var ADV_FALLBACK=0.60, CLEAR_MM=1.5;
// The lowest point a TOP arc reaches: its baseline circle at the sweep ends.
// Longer names subtend more arc, so their ends hang lower - which is exactly
// where the number lives.
function arcBottomY(t,ff,fs,r,ls){
  ls=(ls===undefined?0.4:ls);
  var sweep=run(t,ff,fs,ls).total/r;
  return (C+1.6) - r*Math.cos(Math.min(sweep,Math.PI)/2) + fs*0.10;
}
// The highest point a BOTTOM arc reaches: caps rise from the baseline circle.
function arcTopY(t,ff,fs,r,ls){
  ls=(ls===undefined?0.4:ls);
  var sweep=run(t,ff,fs,ls).total/r;
  return C + r*Math.cos(Math.min(sweep,Math.PI)/2) - fs*capEm(ff);
}
// On a jersey back the NUMBER is the hero. When a long arched name would squeeze
// it, shrink the arc rather than the number, down to a floor.
function arcYielding(t,ff,maxFs,y0,capWanted,botLimit){
  var afs=fitArc(t,ff,maxFs), floor=capWanted*0.72;
  for(var k=0;k<20;k++){
    var top=arcBottomY(t,ff,afs,ARC_R)+CLEAR_MM;
    var cap=2*(y0-top);
    if(botLimit!==undefined) cap=Math.min(cap, 2*(botLimit-y0));
    if(cap>=floor || afs<=4.5) break;
    afs*=0.94;
  }
  return afs;
}
// The arc is a fixed semicircle: fit the string to its available length.
function fitArc(t,ff,maxFs,ls){
  ls=(ls===undefined?0.4:ls);
  var avail=Math.PI*ARC_R*0.88, n=Math.max(t.length,1);
  var fs=(avail-ls*(n-1))/Math.max(advEm(t,ff),0.01);
  return Math.max(4.0, Math.min(maxFs, fs));
}
// Largest size at which t fits the chord available at height y inside radius r.
function fitFS(t,ff,y,maxFs,ls,r){
  // The chord must be measured where the TEXT BOX is widest against the circle,
  // not at the baseline. Caps rise from the baseline toward the rim, where the
  // circle is narrower - measuring at the baseline let long names push past the
  // clip and get cut off. Size and chord depend on each other, so iterate.
  r=r||R_SAFE; ls=(ls===undefined?0.4:ls);
  var sum=advEm(t,ff), n=Math.max(t.length,1), ce=capEm(ff), fs=maxFs;
  for(var k=0;k<10;k++){
    var dy=Math.max(Math.abs(y-fs*ce-C), Math.abs(y-C));
    var half=Math.sqrt(Math.max(r*r-dy*dy,1));
    var nf=(2*half*0.96-ls*(n-1))/Math.max(sum,0.01);
    nf=Math.max(4.0, Math.min(maxFs, nf));
    if(Math.abs(nf-fs)<0.01){ fs=nf; break; }
    fs=nf;
  }
  return fs;
}
// Glyph run: x offsets in mm for each character, plus the total advance.
function run(t,ff,fs,ls){
  var G=(typeof GLYPHS!=="undefined"&&GLYPHS[ff])?GLYPHS[ff].g:null;
  var s=fs/1000, out=[], x=0;
  for(var i=0;i<t.length;i++){
    var ch=t.charAt(i), g=G?G[ch]:null, a=(g?g[0]:600)*s;
    out.push({ch:ch,x:x,adv:a,d:g?g[1]:""});
    x += a + ls;
  }
  return {items:out, total:x - (t.length?ls:0)};
}
function paint(fill,outline){
  return outline ? ' fill="'+fill+'" stroke="'+outline+'" stroke-width="1.5" paint-order="stroke fill"'
                 : ' fill="'+fill+'"';
}


function txt(t,y,fs,fill,ff,ls,weight,outline){
  ls=(ls===undefined?0.4:ls);
  if(typeof GLYPHS==="undefined" || !GLYPHS[ff]){
    var st = outline ? ' stroke="'+outline+'" stroke-width="1.5" paint-order="stroke fill"' : '';
    return '<text x="'+C+'" y="'+y.toFixed(3)+'" fill="'+fill+'"'+st+' font-family="'+ff+'" font-weight="'+(weight||700)+
           '" font-size="'+fs.toFixed(3)+'" letter-spacing="'+ls+'" text-anchor="middle">'+esc(t)+'</text>';
  }
  var r=run(t,ff,fs,ls), x0=C-r.total/2, s=fs/1000, p=[];
  for(var i=0;i<r.items.length;i++){
    var it=r.items[i]; if(!it.d) continue;
    p.push('<path transform="translate('+(x0+it.x).toFixed(3)+' '+y.toFixed(3)+') scale('+s.toFixed(6)+')" d="'+it.d+'"/>');
  }
  return '<g'+paint(fill,outline)+'>'+p.join('')+'</g>';
}
function num(t,cap,fill,ff,outline,cy,minTop,maxBot){
  // cap height sets the size, but width can bind first: "88" in Archivo Black at
  // cap 34 is 64.8 mm wide against a 63.5 mm safe circle. Whichever constraint
  // binds first wins, and the baseline then follows the TRUE cap height.
  // The "number" may be a word on a coach or staff puck. Letters and digits have
  // slightly different cap heights, so size against whichever the string actually
  // uses, and let the width constraint below shrink a long word to fit.
  var y0=(cy===undefined?NUM_Y:cy);
  var hasAlpha=/[^0-9]/.test(t);
  var ce=hasAlpha ? capLOf(ff) : capEm(ff);
  var fs=cap/ce, adv=Math.max(advEm(t,ff),0.01);
  for(var k=0;k<10;k++){
    var dy=Math.abs(y0-C)+fs*ce/2;                 // the far corner of the number
    var half=Math.sqrt(Math.max(R_SAFE*R_SAFE-dy*dy,1));
    var nf=Math.min(cap/ce, 2*half*0.96/adv);
    if(minTop!==undefined) nf=Math.min(nf, 2*Math.max(y0-minTop,0.5)/ce);
    if(maxBot!==undefined) nf=Math.min(nf, 2*Math.max(maxBot-y0,0.5)/ce);
    if(Math.abs(nf-fs)<0.01){ fs=nf; break; }
    fs=nf;
  }
  return txt(t, y0+(fs*ce)/2, fs, fill, ff, 0, 700, outline);
}
function band(y,h,c){return '<rect x="0" y="'+y.toFixed(3)+'" width="76.2" height="'+h.toFixed(3)+'" fill="'+c+'"/>';}
function flood(c){return '<circle cx="'+C+'" cy="'+C+'" r="'+R_PRINT+'" fill="'+c+'"/>';}
function arc(id,t,r,fs,fill,ff,bottom,weight,ls){
  ls=(ls===undefined?0.4:ls);
  if(typeof GLYPHS==="undefined" || !GLYPHS[ff]){
    var d = bottom ? 'M '+(C-r)+','+C+' A '+r+','+r+' 0 0 0 '+(C+r)+','+C
                   : 'M '+(C-r)+','+(C+1.6)+' A '+r+','+r+' 0 0 1 '+(C+r)+','+(C+1.6);
    return '<path id="'+id+'" d="'+d+'" fill="none"/><text fill="'+fill+'" font-family="'+ff+
           '" font-weight="'+(weight||700)+'" font-size="'+fs.toFixed(3)+'" letter-spacing="'+ls+
           '"><textPath href="#'+id+'" startOffset="50%" text-anchor="middle">'+esc(t)+'</textPath></text>';
  }
  // Walk each glyph around the circle, rotating it to sit tangent to the arc.
  var cy = bottom ? C : C+1.6;
  var rr = run(t,ff,fs,ls), s=fs/1000, p=[];
  var sweep = rr.total/r;                       // radians subtended by the whole string
  var start = bottom ? (Math.PI/2 + sweep/2) : (-Math.PI/2 - sweep/2);
  var dir   = bottom ? -1 : 1;
  for(var i=0;i<rr.items.length;i++){
    var it=rr.items[i]; if(!it.d) continue;
    // Place each glyph by the MIDPOINT of its advance, not its left edge, then
    // rotate about that midpoint. Anchoring at the left edge orients every glyph
    // to the tangent where it starts rather than where its mass sits - roughly 6
    // degrees behind, with the centre riding ~0.15 mm off the arc. With ~13
    // degrees of turn between letters that reads as the string snapping round in
    // steps instead of flowing.
    var mid = it.x + it.adv/2;
    var a = start + dir*(mid/r);
    var x = C + r*Math.cos(a), y = cy + r*Math.sin(a);
    // Orient along the direction of travel, which reverses on the bottom arc.
    var rot = Math.atan2(dir*Math.cos(a), -dir*Math.sin(a))*180/Math.PI;
    p.push('<path transform="translate('+x.toFixed(3)+' '+y.toFixed(3)+') rotate('+rot.toFixed(3)+
           ') translate('+(-it.adv/2).toFixed(4)+' 0) scale('+s.toFixed(6)+')" d="'+it.d+'"/>');
  }
  return '<g'+paint(fill,null)+'>'+p.join('')+'</g>';
}


// -- Contrast: pick the palette colour that actually reads on a given ground --
function _lin(v){v/=255;return v<=0.04045?v/12.92:Math.pow((v+0.055)/1.055,2.4);}
function lum(hex){var m=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if(!m)return 0; return 0.2126*_lin(parseInt(m[1],16))+0.7152*_lin(parseInt(m[2],16))+0.0722*_lin(parseInt(m[3],16));}
function ratio(a,b){var la=lum(a),lb=lum(b);return (Math.max(la,lb)+0.05)/(Math.min(la,lb)+0.05);}
// Prefer the team's own colours in the order given; only fall back when a colour
// genuinely will not read. Maximum contrast would always pick white and throw the
// palette away, which defeats the point of choosing a colourway.
var MIN_CONTRAST=3.0;
function on(ground,cands,min){
  min=min||MIN_CONTRAST;
  for(var i=0;i<cands.length;i++){ if(ratio(ground,cands[i])>=min) return cands[i]; }
  var fb=["#FFFFFF","#141414"], best=fb[0], bc=0;
  for(var j=0;j<fb.length;j++){var c=ratio(ground,fb[j]); if(c>bc){bc=c;best=fb[j];}}
  return best;
}
// How far a colour is from grey. Used to break ties toward the team's actual colour
// rather than defaulting to white every time on a bare puck.
function chroma(hex){var m=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex); if(!m)return 0;
  var r=parseInt(m[1],16),g=parseInt(m[2],16),b=parseInt(m[3],16);
  return (Math.max(r,g,b)-Math.min(r,g,b))/255;}
// Pick the most colourful candidate that still reads on the ground.
function tint(ground,cands,min){
  min=min||MIN_CONTRAST;
  var best=null,bx=-1;
  for(var i=0;i<cands.length;i++){
    if(ratio(ground,cands[i])>=min){ var x=chroma(cands[i]); if(x>bx){bx=x;best=cands[i];} }
  }
  return best!==null?best:on(ground,cands,min);
}
var PUCK="#141414";

// An outline has two jobs: separate the glyph from its fill, and separate it from
// EVERY ground the lettering crosses. Scoring on the worst of those is what stops
// an outline vanishing where the design changes colour behind it.
// Trim is tried first - it is the palette's third colour and is rarely a ground.

// Worst-case contrast of a colour against a set of grounds.
function minAgainst(c,grounds){var w=99;for(var i=0;i<grounds.length;i++)w=Math.min(w,ratio(c,grounds[i]));return w;}
// The candidate that reads best against ALL grounds - used when lettering crosses
// more than one colour.
function bestAgainst(grounds,cands){var best=cands[0],bs=-1;
  for(var i=0;i<cands.length;i++){var s=minAgainst(cands[i],grounds); if(s>bs){bs=s;best=cands[i];}}
  return best;}
// An outline exists to rescue the grounds the fill cannot handle on its own.
// So it is judged against the FILL and against those weak grounds only - judging it
// against grounds the fill already clears throws away outlines that were doing a job.
// Where the fill reads everywhere, no outline is drawn: a redundant one just thickens
// and muddies the letterform.
function edgeOrNone(fill,grounds,p,min){
  min=min||2.0;
  var weak=[];
  for(var i=0;i<grounds.length;i++) if(ratio(fill,grounds[i])<min) weak.push(grounds[i]);
  if(!weak.length) return null;
  var need=weak.concat([fill]);
  var cands=[p[4],p[3],p[2],"#FFFFFF","#141414"], best=null, bs=-1;
  for(var j=0;j<cands.length;j++){
    var s=minAgainst(cands[j],need);
    if(s>bs){bs=s;best=cands[j];}
  }
  return best;
}

// --- Palette fidelity -------------------------------------------------------
// The customer picked three colours. The lettering should use those three and
// nothing else. White and charcoal are a last resort, reached for only when no
// combination of the customer's own colours is legible on the grounds it crosses.
// A ground "reads" if the fill clears it, OR if an outline does the rescuing.
function reads(fill,outline,ground,min){
  return ratio(fill,ground)>=min || (!!outline && ratio(outline,ground)>=min);}
function legible(fill,outline,grounds,min){
  for(var i=0;i<grounds.length;i++) if(!reads(fill,outline,grounds[i],min)) return false;
  return true;}
// Outline chooser restricted to the palette.
function edgePal(fill,grounds,p,min){
  var weak=[];
  for(var i=0;i<grounds.length;i++) if(ratio(fill,grounds[i])<min) weak.push(grounds[i]);
  if(!weak.length) return null;
  var need=weak.concat([fill]), cands=[p[4],p[3],p[2]], best=null,bs=-1;
  for(var j=0;j<cands.length;j++){var sc=minAgainst(cands[j],need); if(sc>bs){bs=sc;best=cands[j];}}
  return best;}
// Worst-case effective contrast of a fill+outline mark across its grounds.
function markWorst(fill,outline,grounds){
  var w=99;
  for(var i=0;i<grounds.length;i++)
    w=Math.min(w, Math.max(ratio(fill,grounds[i]), outline?ratio(outline,grounds[i]):0));
  return w;}
// Two thresholds, doing two different jobs:
//   FLOOR (2.0) is the hard legibility bar. Only failing it may push us off-palette.
//   BOOST (2.5) is a soft bar - if a mark clears the floor but sits under BOOST, we
//   add a palette outline PROVIDED it measurably improves the worst case. This lifts
//   muddy pairings like cream-on-gold without ever introducing a fourth colour.
// Chasing a higher floor is not an option here: several palettes contain no colour
// that clears 3.0:1 against their own mid-tone gold, so a higher bar would force the
// very off-palette black this rule exists to prevent.
var FLOOR=2.0, BOOST=2.5;
// Returns {f:fill, o:outline|null, x:true if it had to leave the palette}.
function pair(grounds,p,min){
  min=min||FLOOR;
  var pal=[p[4],p[3],p[2]];
  function dress(fill){
    var eo=edgePal(fill,grounds,p,min);                 // rescue a failing ground
    if(!eo){                                            // clears the floor - strengthen if marginal
      var bare=markWorst(fill,null,grounds);
      if(bare<BOOST){
        var cand=edgePal(fill,grounds,p,BOOST);
        if(cand && markWorst(fill,cand,grounds)>bare+0.05) eo=cand;
      }
    }
    return eo;}
  var first=bestAgainst(grounds,pal), fo=dress(first);
  if(legible(first,fo,grounds,min)) return {f:first,o:fo,x:false};
  for(var i=0;i<pal.length;i++){
    var eo=dress(pal[i]);
    if(legible(pal[i],eo,grounds,min)) return {f:pal[i],o:eo,x:false};
  }
  var fb=bestAgainst(grounds,pal.concat(["#FFFFFF","#141414"]));
  return {f:fb,o:edgeOrNone(fb,grounds,p,min),x:true};}

function edge(fill,grounds,p,min){
  min=min||2.0;
  function score(c){var w=ratio(c,fill);
    for(var i=0;i<grounds.length;i++) w=Math.min(w,ratio(c,grounds[i]));
    return w;}
  var pref=[p[4],p[3],p[2]];
  for(var i=0;i<pref.length;i++) if(score(pref[i])>=min) return pref[i];
  var fb=["#FFFFFF","#141414"], best=fb[0], bs=-1;
  for(var j=0;j<fb.length;j++){var s=score(fb[j]); if(s>bs){bs=s;best=fb[j];}}
  return best;
}


// -- The ten masters, now taking a palette -----------------------------------
// p = [code, name, primary, secondary, trim, classAsafe]
var STYLES=[
 {id:"J01", name:"Open Block", cls:"A", draw:function(p,f,n,no,u){
   var t=on(PUCK,[p[3],p[4]]), ch=on(PUCK,[p[4],p[3]]), num1=tint(PUCK,[p[2],p[3],p[4]]);
   return band(58.9,2.0,ch)+band(64.9,2.0,ch)
        + txt(n,NAME_Y,fitFS(n,f,NAME_Y,10.0),t,f)+num(no,34,num1,f);}},
 {id:"J02", name:"Nameplate Bar", cls:"A", draw:function(p,f,n,no,u){
   var bar=on(PUCK,[p[2],p[3]]), onBar=on(bar,[p[2],p[3],p[4]]);
   var nc=tint(PUCK,[p[4],p[2],p[3]]);
   return band(16.5,14.0,bar)+txt(n,28.0,fitFS(n,f,24.0,9.0),onBar,f)+num(no,27,nc,f,null,46.0);}},
 {id:"J03", name:"Shoulder Yoke", cls:"B", draw:function(p,f,n,no,u){
   var yoke=p[2], onYoke=on(yoke,[p[3],p[4]]), numc=tint(PUCK,[p[2],p[3],p[4]]);
   return band(0,20.5,yoke)+txt(n,18.5,fitFS(n,f,18.5,10.0),onYoke,f)+num(no,34,numc,f,null,44.0);}},
 {id:"J04", bg:1, name:"Twin Hem", cls:"B", draw:function(p,f,n,no,u){
   var body=p[2], ink=on(body,[p[3],p[4]]);
   var c2=on(body,[p[4],p[3]]);
   var afs=arcYielding(n,f,9.0,NUM_Y,24,56.5-CLEAR_MM);
   return flood(body)+band(56.5,5.0,p[3])+band(65.5,5.0,c2)
        + arc("a"+u,n,ARC_R,afs,ink,f)
        + num(no,24,ink,f,null,undefined,arcBottomY(n,f,afs,ARC_R)+CLEAR_MM,56.5-CLEAR_MM);}},
 {id:"J05", bg:1, name:"Triple Retro", cls:"C", draw:function(p,f,n,no,u){
   var body=p[2], ink=on(body,[p[3],p[4]]);
   return flood(body)+band(53.0,6.0,p[3])+band(61.0,2.5,p[4])+band(65.5,6.0,p[3])
        + txt(n,NAME_Y,fitFS(n,f,NAME_Y,10.0),ink,f)+num(no,24,ink,f,null,38.5);}},
 {id:"J06", bg:1, name:"Vertical Split", cls:"C", draw:function(p,f,n,no,u){
   var pr=pair([p[2],p[3]],p), ink=pr.f, outline=pr.o;
   return '<rect x="0" y="0" width="'+C+'" height="76.2" fill="'+p[2]+'"/>'
        + '<rect x="'+C+'" y="0" width="'+C+'" height="76.2" fill="'+p[3]+'"/>'
        + txt(n,25.0,fitFS(n,f,25.0,10.0),ink,f,0.4,700,outline)+num(no,30,ink,f,outline,43.5);}},
 {id:"J07", bg:1, name:"Diagonal Sash", cls:"C", draw:function(p,f,n,no,u){
   var body=p[2], sash=p[3],
       pr=pair([sash,body],p), ink=pr.f, eo=pr.o;
   return flood(body)+'<rect x="-15" y="'+(C-11)+'" width="106" height="22" fill="'+sash+
          '" transform="rotate(-30 '+C+' '+C+')"/>'
        + txt(n,25.0,fitFS(n,f,25.0,10.0),ink,f,0.4,700,eo)+num(no,30,ink,f,eo,43.5);}},
 {id:"J08", name:"Arched Name", cls:"A", draw:function(p,f,n,no,u){
   var ink=tint(PUCK,[p[2],p[3],p[4]]), sec=on(PUCK,[p[4],p[3]]);
   var sfs=FS(4.5,f), botLim=arcTopY("2026 SEASON",f,sfs,28.0,0.6)-CLEAR_MM;
   var afs=arcYielding(n,f,9.0,NUM_Y,26,botLim);
   return arc("b"+u,n,ARC_R,afs,ink,f)
        + num(no,26,ink,f,null,undefined,arcBottomY(n,f,afs,ARC_R)+CLEAR_MM,botLim)
        + arc("c"+u,"2026 SEASON",28.0,sfs,sec,f,true,500,0.6);}},
 {id:"J09", bg:1, name:"Ring Border", cls:"B", draw:function(p,f,n,no,u){
   var body=p[2], ring=p[3], ink=on(body,[p[4],p[3]]);
   return '<circle cx="'+C+'" cy="'+C+'" r="32" fill="'+body+'"/>'
        + '<circle cx="'+C+'" cy="'+C+'" r="34" fill="none" stroke="'+ring+'" stroke-width="4"/>'
        + txt(n,26.0,fitFS(n,f,26.0,10.0),ink,f)+num(no,26,ink,f,null,45.0);}},
 {id:"J10", name:"Modern Minimal", cls:"A", draw:function(p,f,n,no,u){
   var numc=tint(PUCK,[p[2],p[3],p[4]]), nm=numc;  // name inherits the number's colour:
   // picking them with two different functions made J10 inconsistent across palettes
   // (PAL-19 both orange, PAL-23 pink number + white name). numc already clears contrast.
   return num(no,32.3,numc,f,edgeOrNone(numc,[PUCK],p),34.0)
        + txt(n,59.0,6.2,nm,f,0.5,500);}}
];


// -- Roster backs -------------------------------------------------------------
// The reverse face of a double-sided puck: the whole team on one design, so it
// is identical across the run and carries no per-puck admin. Two columns is the
// only arrangement that keeps 18 names above ~2 mm cap, which is about the floor
// for text that reads reliably on rubber.
function txtAt(t,x,y,fs,fill,ff,anchor,ls){
  ls=(ls===undefined?0.2:ls);
  var r=run(t,ff,fs,ls);
  var x0 = anchor==="middle" ? x-r.total/2 : (anchor==="end" ? x-r.total : x);
  var s=fs/1000, p=[];
  for(var i=0;i<r.items.length;i++){
    var it=r.items[i]; if(!it.d) continue;
    p.push('<path transform="translate('+(x0+it.x).toFixed(3)+' '+y.toFixed(3)+') scale('+s.toFixed(6)+')" d="'+it.d+'"/>');
  }
  return '<g fill="'+fill+'">'+p.join('')+'</g>';
}
// Largest font at which every entry fits the column width available at its row.
// Past about twenty players, line height rather than width becomes the limit, so
// dropping the jersey numbers does not help - the rows themselves get too tight.
// Three narrower columns holds a steady 2.18 mm cap at any roster size, so large
// rosters switch to three columns and lose the numbers to buy back the width.
function rosterCols(n){ return n>20 ? 3 : 2; }
// The roster list is text, not display type. Graduate and Archivo Black are the wide
// faces and cannot hold a roster line above the ~2 mm cap that reads on rubber, so the
// list always sets in a condensed face while the team name keeps the customer's choice.
// A roster-only puck makes this a non-issue anyway: there is no front to match.
var ROSTER_FACE="Oswald";
function rosterFace(ff){
  if(typeof GLYPHS==="undefined") return ff;
  var wide = advEm("M",ff) > 0.85;              // Graduate 1.026, Archivo Black 1.000
  return wide ? ROSTER_FACE : ff;
}
function rosterShowNums(n){ return n<=20; }
function rosterFS(list,ff,cols,top,bot,colW,maxCap,nums){
  // Measure what will actually be drawn. Sizing against "49 VANDERBEEK" while only
  // printing "VANDERBEEK" costs about half a millimetre of cap height on exactly
  // the rosters that can least afford it.
  if(nums===undefined) nums=true;
  var rows=Math.ceil(list.length/cols), lineH=(bot-top)/rows;
  var wide=0;
  for(var i=0;i<list.length;i++)
    wide=Math.max(wide, advEm(nums ? list[i][0]+" "+list[i][1] : list[i][1], ff));
  var byLine  = (lineH*0.62)/capLOf(ff);
  var byWidth = colW/Math.max(wide,0.01);
  return Math.min(byLine, byWidth, (maxCap||4.0)/capLOf(ff));
}
var BACKS=[
 {id:"R01", name:"Two Column", draw:function(p,f,team,season,list,u){
   var body=p[2], ink=on(body,[p[4],p[3]]), head=on(body,[p[3],p[4]]);
   var lf=rosterFace(f);
   var top=21.0, bot=59.0, cols=rosterCols(list.length), nums=rosterShowNums(list.length);
   var colW = cols===2 ? 23.0 : 15.5;
   var fs=rosterFS(list,lf,cols,top,bot,colW,3.4,nums);
   var rows=Math.ceil(list.length/cols), lineH=(bot-top)/rows;
   var span = cols===2 ? 50.0 : 51.0, x0 = C - span/2, step = span/cols;
   var out=[flood(body)];
   out.push(txtAt(team, C, 15.0, fitFS(team,f,15.0,7.0,0.3,29.0), head, f, "middle", 0.3));
   for(var i=0;i<list.length;i++){
     var c=Math.floor(i/rows), r=i%rows;
     var x = x0 + c*step;
     var y = top + r*lineH + lineH*0.78;
     if(nums){
       out.push(txtAt(list[i][0], x+5.0, y, fs, head, lf, "end", 0.2));
       out.push(txtAt(list[i][1], x+7.0, y, fs, ink,  lf, "start", 0.2));
     } else {
       out.push(txtAt(list[i][1], x+step/2, y, fs, ink, lf, "middle", 0.2));
     }
   }
   if(season) out.push(txtAt(season, C, 66.5, 4.6, head, f, "middle", 0.5));
   return out.join("");}},

 {id:"R02", name:"Arc Header", draw:function(p,f,team,season,list,u){
   // A full ring of names puts half of them upside down at the bottom, which reads
   // badly at 18 players. Arcs carry the team name and season instead, and the
   // roster stays in the two upright columns that actually get read.
   var body=p[2], ink=on(body,[p[4],p[3]]), head=on(body,[p[3],p[4]]);
   var lf=rosterFace(f);
   var top=25.0, bot=57.0, cols=rosterCols(list.length), nums=rosterShowNums(list.length);
   var colW = cols===2 ? 22.0 : 14.5;
   var fs=rosterFS(list,lf,cols,top,bot,colW,3.2,nums);
   var rows=Math.ceil(list.length/cols), lineH=(bot-top)/rows;
   var span = cols===2 ? 48.0 : 49.0, x0 = C - span/2, step = span/cols;
   var out=[flood(body)];
   out.push('<circle cx="'+C+'" cy="'+C+'" r="33.2" fill="none" stroke="'+head+'" stroke-width="1.0"/>');
   out.push(arc("rt"+u, team, 27.5, fitArc(team,f,7.0), head, f));
   for(var i=0;i<list.length;i++){
     var c=Math.floor(i/rows), r=i%rows;
     var x = x0 + c*step;
     var y = top + r*lineH + lineH*0.78;
     if(nums){
       out.push(txtAt(list[i][0], x+5.0, y, fs, head, lf, "end", 0.2));
       out.push(txtAt(list[i][1], x+7.0, y, fs, ink,  lf, "start", 0.2));
     } else {
       out.push(txtAt(list[i][1], x+step/2, y, fs, ink, lf, "middle", 0.2));
     }
   }
   if(season) out.push(arc("rb"+u, season, 29.0, 4.6, head, f, true, 500, 0.5));
   return out.join("");}}
];
function backSVG(idx, pal, font, team, season, list, uid, showBody){
  var b=BACKS[idx];
  var art=b.draw(pal, font, (team||"").toUpperCase(), (season||"").toUpperCase(), list||[], uid);
  var body = showBody===false ? '' :
    '<circle cx="'+C+'" cy="'+C+'" r="'+R_FACE+'" fill="#141414"/>';
  return '<svg viewBox="0 0 76.2 76.2" xmlns="http://www.w3.org/2000/svg">'
       + '<defs><clipPath id="cb'+uid+'"><circle cx="'+C+'" cy="'+C+'" r="'+R_PRINT+'"/></clipPath></defs>'
       + body + '<g clip-path="url(#cb'+uid+')">'+art+'</g></svg>';
}

function puckSVG(styleIdx, pal, font, name, number, uid, showRim){
  var s=STYLES[styleIdx];
  var art=s.draw(pal, font, (name||"").toUpperCase(), number||"", uid);
  // Nathan's call, 24 Aug 2026: nothing relies on bare rubber showing through.
  // Styles that used the black puck as their ground now print an actual black
  // flood over primer and white, which reads more uniform than the blank does.
  // Styles that already flood are left alone - a second ground underneath would
  // only waste ink and risk shifting the colour on top.
  // s.bg marks the styles that already cover the whole printable disc: a flood,
  // the two split halves, or J09's disc plus ring. The rest get a printed black
  // ground. Adding one under a style that already covers would print black under
  // colour - wasted ink and a duller top colour.
  if(!s.bg) art = flood(PUCK) + art;
  var rim = showRim===false ? '' :
    '<circle cx="'+C+'" cy="'+C+'" r="37.2" fill="none" stroke="#2C2C2C" stroke-width="2" stroke-dasharray="0.8 1.4"/>';
  return '<svg viewBox="0 0 76.2 76.2" xmlns="http://www.w3.org/2000/svg">'
       + '<defs><clipPath id="cp'+uid+'"><circle cx="'+C+'" cy="'+C+'" r="'+R_PRINT+'"/></clipPath></defs>'
       + '<circle cx="'+C+'" cy="'+C+'" r="'+R_FACE+'" fill="#141414"/>'+rim
       + '<g clip-path="url(#cp'+uid+')">'+art+'</g></svg>';
}


var PALS=[
  ["PAL-01","Navy / White / Gold","#0B2545","#FFFFFF","#C9A227",0],
  ["PAL-02","Red / White / Navy","#C8102E","#FFFFFF","#0B2545",1],
  ["PAL-03","Black / Gold / White","#141414","#C9A227","#FFFFFF",0],
  ["PAL-04","Royal / White / Silver","#0057B8","#FFFFFF","#C4C8CC",0],
  ["PAL-05","Forest / Cream / Gold","#14532D","#F7E8D3","#C9A227",0],
  ["PAL-06","Maroon / Grey / White","#6E1423","#9BA3AA","#FFFFFF",0],
  ["PAL-07","Purple / Silver / White","#4C1D95","#C4C8CC","#FFFFFF",0],
  ["PAL-08","Teal / Black / White","#0F7B7B","#141414","#FFFFFF",1],
  ["PAL-09","Orange / Navy / White","#E36414","#0B2545","#FFFFFF",1],
  ["PAL-10","Powder Blue / Navy / White","#7FB3D5","#0B2545","#FFFFFF",1],
  ["PAL-11","Kelly Green / Gold / White","#1B7A3E","#C9A227","#FFFFFF",1],
  ["PAL-12","Burgundy / Gold / Cream","#7B1E3A","#C9A227","#F7E8D3",0],
  ["PAL-13","Sky / White / Charcoal","#4EA8DE","#FFFFFF","#141414",1],
  ["PAL-14","Crimson / Navy / White","#9E1B32","#0B2545","#FFFFFF",0],
  ["PAL-15","Steel Grey / Red / White","#6B7280","#C8102E","#FFFFFF",1],
  ["PAL-16","Black / White","#141414","#FFFFFF","#9BA3AA",0],
  ["PAL-17","Navy / Gold","#0B2545","#C9A227","#FFFFFF",0],
  ["PAL-18","Red / Black / White","#C8102E","#141414","#FFFFFF",1],
  ["PAL-19","Teal / White / Orange","#0F7B7B","#FFFFFF","#E36414",1],
  ["PAL-20","Purple / Gold / Black","#4C1D95","#C9A227","#141414",0],
  ["PAL-21","Orange / Black / White","#E36414","#141414","#FFFFFF",1],
  ["PAL-22","Brown / Gold / Cream","#5C4033","#C9A227","#F7E8D3",0],
  ["PAL-23","Pink / White / Charcoal","#E75480","#FFFFFF","#141414",1],
  ["PAL-24","PrintABalls Navy / Aqua / Cream","#045C90","#00CFC8","#F7E8D3",0]
];
var FONTS=[["NUM-01","Block","Oswald"],["NUM-02","Condensed","Anton"],["NUM-03","Collegiate","Graduate"],
           ["NUM-04","Heavy","Archivo Black"],["NUM-05","Wide","Big Shoulders Display"]];
var st=0, pi=1, fi=0, uid=0;







function currentName(){ return (document.getElementById('nm').value||'').toUpperCase().replace(/[^A-Z\u00C0\u00C1\u00C2\u00C4\u00C6\u00C7\u00C8\u00C9\u00CA\u00CB\u00CD\u00CE\u00CF\u00D1\u00D3\u00D4\u00D6\u00D8\u00D9\u00DA\u00DB\u00DC\u00DD' -]/g,''); }
function currentNum(){ return (document.getElementById('no').value||'').replace(/[^0-9]/g,''); }


